import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import { BrowserRouter, Route,Router, Switch,Link } from 'react-router-dom'

export default class Footer extends Component {
    render() {
        return (
            <div className="footer">
            <h3>Footer</h3>
            </div>
        )
    }      
}